/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_ConfirmInputs */

const en_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ХОРОШО`)
};

const es_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DE ACUERDO`)
};

const zh_cn2_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_work_order_publish_auth_confirm = /** @type {(inputs: Work_Order_Publish_Auth_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Work_Order_Publish_Auth_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_confirm = /** @type {((inputs?: Work_Order_Publish_Auth_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_auth_confirm(inputs)
	if (locale === "de") return de_work_order_publish_auth_confirm(inputs)
	if (locale === "it") return it_work_order_publish_auth_confirm(inputs)
	if (locale === "ru") return ru_work_order_publish_auth_confirm(inputs)
	if (locale === "es") return es_work_order_publish_auth_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_auth_confirm(inputs)
	if (locale === "ja") return ja_work_order_publish_auth_confirm(inputs)
	if (locale === "hi") return hi_work_order_publish_auth_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_auth_confirm(inputs)
	return en_work_order_publish_auth_confirm(inputs)
});